import React from 'react';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import HomeIcon from '@mui/icons-material/Home';
import GamesIcon from '@mui/icons-material/Games';
import HistoryIcon from '@mui/icons-material/History';
import AddIcon from '@mui/icons-material/Add';
import ScienceIcon from '@mui/icons-material/Science';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import { canCreateInSpace } from '../../utils/roles';

const MobileNavigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, gamespaceRole } = useAuth();
  const [value, setValue] = React.useState('/');

  React.useEffect(() => {
    const path = location.pathname;
    if (path === '/game-cards') setValue('/game-cards');
    else if (path.startsWith('/moments')) setValue('/moments');
    else if (path === '/player/sessions') setValue('/player/sessions');
    else if (path === '/create-game') setValue('/create-game');
    else if (path === '/simulation') setValue('/simulation');
    else setValue('/');
  }, [location.pathname]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(newValue);
  };

  // Only show on mobile and when authenticated
  if (!isAuthenticated) return null;

  return (
    <Paper 
      sx={{ 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        right: 0, 
        zIndex: 1000,
        display: { xs: 'block', md: 'none' } // Only show on mobile
      }} 
      elevation={3}
    >
      <BottomNavigation value={value} onChange={handleChange}>
        <BottomNavigationAction
          label="Home"
          value="/"
          icon={<HomeIcon />}
        />
        <BottomNavigationAction
          label="Games"
          value="/game-cards"
          icon={<GamesIcon />}
        />
        <BottomNavigationAction
          label="Moments"
          value="/moments"
          icon={<LightbulbOutlinedIcon />}
        />
        <BottomNavigationAction
          label="History"
          value="/player/sessions"
          icon={<HistoryIcon />}
        />
        {canCreateInSpace(gamespaceRole) && (
          <BottomNavigationAction
            label="Create"
            value="/create-game"
            icon={<AddIcon />}
          />
        )}
        <BottomNavigationAction
          label="Simulation"
          value="/simulation"
          icon={<ScienceIcon />}
        />
      </BottomNavigation>
    </Paper>
  );
};

export default MobileNavigation;
